<template>
<!-- Display on mobile -->
<v-content v-if="this.$vuetify.breakpoint.smAndDown" class="project">

  <v-card :color="project.color" class="mx-auto" max-width="600" tile raised>
    <v-card-title class="font-weight-thin subheading" v-text="project.title">
    </v-card-title>
    <v-img contain class="white--text align-end" height="200px" :src="getImgUrl(project.img)" :lazy-src="getImgUrl(project.lazy)">
      <v-card-title class="headline font-weight-thin" v-text="project.title"></v-card-title>
    </v-img>
    <v-card-subtitle v-text="project.description"></v-card-subtitle>
    <v-card-text class="text--primary">
      <div>Link(s)
        <v-btn class="ml-2" v-for="item in project.links" :key="item.id" x-small @click="goToExternal(item.url)" text v-text="item.name"></v-btn>
      </div>
    </v-card-text>

  </v-card>
</v-content>

<!-- Display on other surfaces than mobile -->
<v-content v-else class="project">
  <!-- For parallax -->
  <v-parallax v-if="project.id % 2 === 0" :src="getWallpaperUrl(wallpapers[project.id])">
    <v-row align="center" justify="space-around">
      <v-col cols="4">
        <v-hover v-slot:default="{ hover }" close-delay="200">
          <v-card class="mx-auto" max-width="344" :elevation="hover ? 16 : 2" tile>
            <v-img :src="getImgUrl(project.img)" :lazy-src="getImgUrl(project.lazy)" height="200px"></v-img>
            <v-card-title>
              <v-list>
                <v-list-item class="my-n4" v-for="item in project.links" :key="item.id">
                  <v-icon class="mr-2" color="grey lighten-1">mdi-information</v-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-btn x-small @click="goToExternal(item.url)" text v-text="item.name"></v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-col>
      <v-col class="text-center" cols="6">
        <h1 class="font-weight-thin subheading">{{ project.title }}</h1>
        <p>{{ project.description }}</p>
      </v-col>
    </v-row>
  </v-parallax>
  <!-- For non parallax -->
  <v-row v-else class="non-parallax" align="center" justify="space-around">
    <v-col class="text-center" cols="6">
      <h1 class="font-weight-thin subheading">{{ project.title }}</h1>
      <p>{{ project.description }}</p>
    </v-col>
    <v-col cols="4">
      <v-hover v-slot:default="{ hover }" close-delay="200">
        <v-card class="mx-auto" max-width="344" :elevation="hover ? 16 : 2" tile>
          <v-img :src="getImgUrl(project.img)" :lazy-src="getImgUrl(project.lazy)" height="200px"></v-img>
          <v-card-title>
            <v-list>
              <v-list-item class="my-n4" v-for="item in project.links" :key="item.id">
                <v-icon class="mr-2" color="grey lighten-1">mdi-information</v-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-btn x-small @click="goToExternal(item.url)" text v-text="item.name"></v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>


          </v-card-title>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</v-content>
</template>

<script>
export default {
  name: 'Project',
  props: {
    project: {
      id: Number,
      title: String,
      img: String,
      lazy: String,
      link: Array,
      description: String,
      required: true,
      default: null
    }
  },
  data() {
    return {
      wallpapers: ['0', '1', '2']
    }
  },
  methods: {
    getImgUrl(pet) {
      var images = require.context('../assets/projects/', false, /\.png$/);
      return images('./' + pet + ".png");
    },
    getWallpaperUrl(name) {
      var images = require.context('../assets/parallax/', false, /\.jpg$/);
      return images('./' + name + ".jpg");
    },
    goToExternal(url) {
      // window.location.href = url;
      window.open(url, '_blank');
    }
  }

}
</script>

<style Scoped>
.non-parallax {
  height: 75vh;
}
</style>
